<template>
    <div class="nobind h5content column ">
        <img :src="listempty2" class="emptyImg">
        <div class="fc666">
            系统升级维护中，请稍后再试...
        </div>
    </div>
</template>

<script>
import listempty2 from "@/assets/img/listempty2.png"

export default {
    name: '503',
    props: [],
    components: {},
    data: function () {
        return {
            listempty2
        }
    },
    setup() {

    },

    mounted: function () {},
    methods: {}
}
</script>

<style lang="scss" scoped>
.emptyImg{
    width:4.167rem;
    margin: 0 auto;
    display: block;
}
.fc666{
    margin-top: .417rem;
}
.nobind {
    padding: .625rem .833rem;
}
</style>
